import { Component, OnInit } from '@angular/core';
import { version } from '@version';
import { Observable, of } from 'rxjs';
import { AppSettingsQuery, LanguageService, ListValue } from 'chronos-shared';
import { HeaderService, PileTurnerWorkCenterService } from '@pt/core/services';
import { map, share } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'pt-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  public version = version;

  public currentLanguage$!: Observable<string>;
  public hasWorkCenterSelection$: Observable<boolean>;
  public currentPileTurnerName$!: Observable<string>;
  public pileTurnerOptions$!: Observable<ListValue[]>;
  public supportedLanguages$: Observable<ListValue[]>;
  public applicationName: string;
  public currentPileTurnerId?: number;
  public isProductionEnvironment$: Observable<boolean>;

  constructor(
    private languageService: LanguageService,
    private headerService: HeaderService,
    public appSettingsQuery: AppSettingsQuery,
    private pileTurnerWorkCenterService: PileTurnerWorkCenterService,
    private translateService: TranslateService
  ) {}

  public ngOnInit(): void {
    this.currentPileTurnerId = this.pileTurnerWorkCenterService.getPileTurnerId();
    this.currentLanguage$ = this.languageService.language$;
    this.hasWorkCenterSelection$ = this.appSettingsQuery.isWorkCenterSelectionEnabled$;
    this.pileTurnerOptions$ = this.headerService.getPileTurners().pipe(share());
    this.currentPileTurnerName$ = this.getCurrentPileTurnerName();
    this.isProductionEnvironment$ = this.appSettingsQuery.isProductionEnvironment$;

    this.hasWorkCenterSelection$.subscribe((feature) => {
      console.info(`hasWorkCenterSelection: ${feature}`);
    });

    // added temporarily, will be replaced with proper solution.
    setTimeout(() => {
      this.supportedLanguages$ = this.languageOptions();
    }, 100);

    this.appSettingsQuery.isPackagramLogoEnabled$.subscribe((isEnabled) => {
    this.applicationName = isEnabled
        ? this.translateService.instant('APP.PILETURNER_APPLICATION')
        : this.translateService.instant('APP.MM_PILETURNER_APPLICATION');
    });
  }

  public onLanguageSelected(lang: string): void {
    if (lang === null) {
      lang = this.currentLanguage$.toString();
    }
    this.languageService.setDefaultLanguage(lang);
  }

  public onPileTurnerChange(newPileTurnerId: number) {
    this.pileTurnerWorkCenterService.setPileTurnerId(newPileTurnerId);
    location.reload();
  }

  private getCurrentPileTurnerName(): Observable<string> {
    return this.pileTurnerOptions$.pipe(
      map((list) => list.find((listValue) => Number(listValue.value) === this.currentPileTurnerId)),
      map((listValue) => listValue?.label || '')
    );
  }

  private languageOptions(): Observable<ListValue[]> {
    return of([
      { label: 'Deutsch', value: 'de' },
      { label: 'English (UK)', value: 'en' },
      { label: 'Español', value: 'es' },
      { label: 'Français', value: 'fr' },
      { label: 'Polski', value: 'pl' },
      { label: 'Română', value: 'ro' },
      { label: 'Debug', value: 'dbg' }
    ]);
  }
}
